import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=165bd9e5&"
import script from "./Advertisement.vue?vue&type=script&lang=js&"
export * from "./Advertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports